import windowutils from '../utils/window';
export default class Table {
  constructor(el) {
    this.el = el;
    this.el.classList.contains('table-ordered') ? this.ordertable() : false;
  }

  ordertable() {
    windowutils.injectcss(
      'https://fonts.googleapis.com/icon?family=Material+Icons'
    );
    const rows = [...this.el.querySelectorAll('tr')];
    const headerrow = rows[0];
    rows.shift();
    const datarows = rows;
    datarows.forEach((el, i) => {
      el.dataset.sortindex = i;
    });
    function sortrows(index, direction) {
      let sorted = datarows.sort(function (a, b) {
        const A = [...a.querySelectorAll('td')][index].querySelector('a')
          ? [...a.querySelectorAll('td')][index].querySelector('a').textContent
          : [...a.querySelectorAll('td')][index].textContent;
        const B = [...b.querySelectorAll('td')][index].querySelector('a')
          ? [...b.querySelectorAll('td')][index].querySelector('a').textContent
          : [...b.querySelectorAll('td')][index].textContent;
        switch (direction) {
          case 'az':
            if (A < B) {
              return -1;
            }
            if (A > B) {
              return 1;
            }
            return 0;
          case 'za':
            if (A > B) {
              return -1;
            }
            if (A < B) {
              return 1;
            }
            return 0;
        }
      });
      return { data: sorted, class: direction };
    }
    function resetrows() {
      let sorted = datarows.sort(function (a, b) {
        const A = parseInt(a.dataset.sortindex);
        const B = parseInt(b.dataset.sortindex);
        if (A < B) {
          return -1;
        }
        if (A > B) {
          return 1;
        }
        return 0;
      });
      return { data: sorted, class: 'initial' };
    }
    let sorted = [];
    [...headerrow.querySelectorAll('th')].forEach((el, i) => {
      if (el.textContent.trim() !== '') {
        el.classList.add('table-sort-by');
        el.addEventListener('click', (e) => {
          sorted = el.classList.contains('az')
            ? sortrows(i, 'za')
            : el.classList.contains('za')
              ? resetrows()
              : sortrows(i, 'az');
          let tablebody = this.el.querySelector('tbody'); //empty table
          tablebody.innerHTML = '';
          tablebody.insertAdjacentElement('beforeend', headerrow);
          sorted.data.forEach((el) => {
            tablebody.insertAdjacentElement('beforeend', el);
          });
          [...headerrow.querySelectorAll('th')].forEach((el, i) => {
            el.classList.remove('table-sorted');
            el.classList.remove('az');
            el.classList.remove('za');
            el.classList.remove('initial');
          });
          el.classList.add(`table-sorted`);
          sorted.class == 'za'
            ? el.classList.remove('az')
            : sorted.class == 'initial'
              ? el.classList.remove('za')
              : el.classList.remove('initial');
          el.classList.add(sorted.class);
        });
      }
    });
  }
}
